import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { decodeOrThrow } from 'src/io/utils/decodeOrThrow';
import { makeRestRequest } from 'src/modules/api/sagas/utils/makeRestRequest';
import { FEEDBACK_REQUEST } from 'src/modules/feedback/codecs/FeedbackRequest';
import { FeedbackRequest } from 'src/modules/feedback/types/FeedbackRequest';
import { call } from 'typed-redux-saga';

export function* sendFeedbackRequestTrigger(): SagaIterator<FeedbackRequest> {
  try {
    const data = yield* call(
      makeRestRequest,
      'PUT',
      '/feedback/request',
    );

    return decodeOrThrow(FEEDBACK_REQUEST, data.content);
  } catch (error) {
    throw new RuntimeError('Could not send feedback request trigger', {}, NativeError.wrap(error));
  }
}
